import React from 'react';
import { useProducts } from '../context/ProductContext';
import ProductCard from '../components/ProductCard';
import '../styles/App.css';

const ProductsPage = () => {
  const { products, loading } = useProducts();

  return (
    <div className="bg-white min-h-screen">
      {/* Header */}
      <section className="py-12 px-8 md:px-[140px] bg-gradient-to-b from-[#8e0707] to-[#6b0505]">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-medium text-white mb-4">
            Our Products
          </h1>
          <p className="text-xl text-white/80">
            Make every day meal, DELICIOUS!
          </p>
        </div>
      </section>

      {/* Products */}
      <section className="py-16 px-8 md:px-[140px]">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {loading ? (
            <p>Loading products...</p>
          ) : (
            products
              .slice() // Create a shallow copy to avoid mutating the original array
              .sort((a, b) => {
                if (a.comingSoon !== b.comingSoon) {
                  return a.comingSoon ? 1 : -1;
                }
                return a.name.localeCompare(b.name);
              })
              .map(product => (
                <ProductCard key={product._id} product={product} />
              ))
          )}
        </div>
      </section>
    </div>
  );
};

export default ProductsPage;
